import type { Baseball } from "@knowsball/common";
import { useGetPlayers } from "./useGetPlayers";
import { useGetTeams } from "./useGetTeams";

export function useEntityMaps() {
	const playersAPI = useGetPlayers();
	const teamsAPI = useGetTeams();

	const players: Record<string, Baseball.Player> = {};
	const teams: Record<string, Baseball.Team> = {};

	for (const player of playersAPI.data?.players ?? []) {
		players[player.normalizedName] = player;
	}

	for (const team of teamsAPI.data?.teams ?? []) {
		teams[team.normalizedName] = team;
	}

	return {
		isLoading: playersAPI.isLoading || teamsAPI.isLoading,
		players,
		teams,
	};
}
